<template>
  <div class="placeholder relative overflow-hidden">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  @keyframes placeHolderShimmer{
      0%{
          transform: translateX(-100%);
      }
      100%{
        transform: translateX(100%);
      }
  }
  .placeholder {
    background-color: rgba(242, 183, 111, .2);
    &:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: linear-gradient(to right, rgba(242, 183, 111, 0), rgba(242, 183, 111, .4) 50%, rgba(242, 183, 111, 0));
      background-repeat: no-repeat;
      animation: 1s placeHolderShimmer forwards infinite linear;
      pointer-events: none;
    }
  }
</style>